// Lib
import gql from 'graphql-tag';
import {
  ANALYTIC_FIELD,
  AUTH,
  AUTH_ANALYTIC,
  GA_STAT,
  POST,
  SHOPIFY_PRODUCT,
} from '../types';

export const getAccountScoreQuery = gql`
  query GetAccountScore($input: GetAcountScoreInput) {
    getAccountScore(input: $input) {
      title
      isCompleted
      items {
        name
        current
        max
      }
    }
  }
`;

export const getProfileViews = gql`
  query GetAccountAnalytics($input: GetAccountAnalyticsInput) {
    getAccountAnalytics(input: $input) {
      profileViews {
        ${ANALYTIC_FIELD}
      }
    }
  }
`;

export const getProfileViewsByDates = gql`
  query GetAccountAnalytics($input: GetAccountAnalyticsInput) {
    getAccountAnalytics(input: $input) {
      profileViewsByDates {
        ${ANALYTIC_FIELD}
      }
    }
  }
`;

export const getAccountEngagement = gql`
  query GetAccountAnalytics($input: GetAccountAnalyticsInput) {
    getAccountAnalytics(input: $input) {
      engagement {
        ${ANALYTIC_FIELD}
      }
    }
  }
`;

export const getEngagementByDates = gql`
  query GetAccountAnalytics($input: GetAccountAnalyticsInput) {
    getAccountAnalytics(input: $input) {
      engagementByDates {
        ${ANALYTIC_FIELD}
      }
    }
  }
`;
export const getPostViews = gql`
  query GetAccountAnalytics($input: GetAccountAnalyticsInput) {
    getAccountAnalytics(input: $input) {
      postViews {
        ${ANALYTIC_FIELD}
      }
    }
  }
`;

export const getPostViewsByDates = gql`
  query GetAccountAnalytics($input: GetAccountAnalyticsInput) {
    getAccountAnalytics(input: $input) {
      postViewsByDates {
        ${ANALYTIC_FIELD}
      }
    }
  }
`;

export const getProfileLinkClicks = gql`
  query GetAccountAnalytics($input: GetAccountAnalyticsInput) {
    getAccountAnalytics(input: $input) {
      profileLinkClicks {
        ${ANALYTIC_FIELD}
      }
    }
  }
`;

export const getProfileLinkClicksByDates = gql`
  query GetAccountAnalytics($input: GetAccountAnalyticsInput) {
    getAccountAnalytics(input: $input) {
      profileLinkClicksByDates {
        ${ANALYTIC_FIELD}
      }
    }
  }
`;

export const getAccountInsightsQuery = gql`
  query GetAccountInsights($input: GetMarbleInsightInput) {
    getAccountInsights(input: $input) {
      _id
      createdAt
      type
      message
      seen
      clickAction
      textLink
      extraData {
        post {
          _id
          source
        }
      }
    }
  }
`;

export const getAllAnalyticsQuery = gql`
  query GetAllAnalytics($input: GetAccountAnalyticsInput) {
    getAccountPlatformStats(input: $input) {
      platform
      linkClicks
      postViews
      conversion
    }
  }
`;

export const getProfileAnalyticsTabQuery = gql`
  query GetProfileAnalyticsTab($input: GetAccountAnalyticsInput) {
    getAccountAnalytics(input: $input) {
      profileViews {
        total
      }
      engagement {
        total
      }
      profileLinkClicks {
        total
      }
    }
  }
`;

export const getProfileStatsQuery = gql`
  query GetProfileStats($input: GetAccountAnalyticsInput) {
    getAccountPlatformStats(input: $input) {
      platform
      linkClicks
      postViews
      conversion
    }
    getAccountAnalytics(input: $input) {
      profileViewsByDates {
        ${ANALYTIC_FIELD}
      }
    }
  }
`;

export const getProductAnalyticsQuery = gql`
  query GetProductAnalytics($input: GetMarbleProductAnalyticInput) {
    productAnalytic(input: $input) {
      mostPopularProducts {
        productTitle
        quantity
      }
      orderStats {
        date
        quantity
      }
      totalOrders
      totalOrderPrices
      views {
        date
        postId
        target
        total
        sources {
          source
          amount
        }
      }
      clicks {
        date
        postId
        target
        total
        sources {
          source
          amount
        }
      }
    }
  }
`;

export const getAnalyticsLinkClicksBySourceQuery = gql`
  query GetAnalyticsLinkClicksBySource($input: GetAccountAnalyticsInput) {
    getAnalyticsLinkClicksBySource(input: $input) {
      ${GA_STAT}
    }
  }
`;

export const getAnalyticsPageViewBySourceQuery = gql`
  query GetAnalyticsPageViewBySource($input: GetAccountAnalyticsInput) {
    getAnalyticsPageViewBySource(input: $input) {
      ${GA_STAT}
    }
  }
`;

export const getAnalyticsEngagementBySourceQuery = gql`
  query GetAnalyticsEngagementBySource($input: GetAccountAnalyticsInput) {
    getAnalyticsEngagementBySource(input: $input) {
      ${GA_STAT}
    }
  }
`;

export const getAnalyticsPageViewByDatesQuery = gql`
  query GetAnalyticsPageViewByDates($input: GetAccountAnalyticsInput) {
    getAnalyticsPageViewByDates(input: $input) {
      ${GA_STAT}
    }
  }
`;

export const getAccountPlatformStats = gql`
  query GetAccountPlatformStats($input: GetAccountAnalyticsInput) {
    getAccountPlatformStats(input: $input) {
      platform
      linkClicks
      postViews
      traffic
    }
  }
`;

export const getAuthAnalytics = gql`
  query GetAuthAnalytics($input: GetAnalyticsInputV2) {
    getAuthAnalytics(input: $input) {
      ${AUTH_ANALYTIC}
    }
  }
`;

export const getSalesAnalytics = gql`
  query GetSalesAnalytics($input: GetAnalyticsInputV2) {
    getSalesAnalytics(input: $input) {
      _id
      createdAt
      updatedAt
      innerId
      authInnerId
      totalPrice {
        amount
        currencyCode
      }
      items {
        productId
        quantity
      }
      products {
        ${SHOPIFY_PRODUCT}
      }
    }
  }
`;

export const getCampaignAnalytics = gql`
  query GetCampaignAnalytics($input: GetAnalyticsInputV2) {
    getCampaignAnalytics(input: $input) {
      orders {
        _id
        createdAt
        updatedAt
        innerId
        authInnerId
        totalPrice {
          amount
          currencyCode
        }
        items {
          productId
          quantity
        }
        products {
          ${SHOPIFY_PRODUCT}
        }
        associatedMarbleIds
      }
      mentionedPosts {
        ${POST}
        authId
        accountId
      }
      authAnalytics {
        ${AUTH_ANALYTIC}
      }
      partnersAuths {
        ${AUTH}
      }
    }
  }
`;

export const getConnectedAnalayticsSessionByDate = gql`
  query GetConnectedAnalayticsSessionByDate($input: GetAnalyticsInputV2) {
    getConnectedAnalayticsSessionByDate(input: $input) {
      key
      value
    }
  }
`;

export const getConnectedAnalayticsSessionBySource = gql`
  query GetConnectedAnalayticsSessionBySource($input: GetAnalyticsInputV2) {
    getConnectedAnalayticsSessionBySource(input: $input) {
      key
      value
    }
  }
`;

export const getConnectedAnalayticsSession = gql`
  query GetConnectedAnalayticsSession($input: GetAnalyticsInputV2) {
    getConnectedAnalayticsSessionByDate(input: $input) {
      key
      value
    }
    getConnectedAnalayticsSessionBySource(input: $input) {
      key
      value
    }
  }
`;
